import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { defineStore, storeToRefs } from 'pinia'
import { useShortcut } from '@nsftx/seven-nxg-retail-vue-sdk'
import { useNavbarStore } from '../navbar/navbarStore'

export const useHeaderStore = defineStore('headerStore', () => {
  const isMainMenuShown = ref(false)
  const pageTitle = ref('')
  const navbarStore = useNavbarStore()
  const { openNavbar, handleShowNavbar, closeNavbar } = navbarStore
  const { isNavbarShown } = storeToRefs(navbarStore)
  const route = useRoute()

  const shouldShowNavbar = computed(() => isNavbarShown.value)

  useShortcut('OPEN_MAIN_MENU', () => {
    toggleMainMenu()
  })

  const openMainMenu = () => {
    isMainMenuShown.value = true
  }

  const closeMainMenu = () => {
    isMainMenuShown.value = false
  }

  const toggleMainMenu = () => {
    if (isMainMenuShown.value) {
      closeMainMenu()
      return
    }

    openMainMenu()
  }

  const setPageTitle = (title: string) => {
    pageTitle.value = title
  }

  watch(
    () => route.path,
    () => {
      closeMainMenu()
      handleShowNavbar()
    },
    {
      immediate: true,
    },
  )

  return {
    isMainMenuShown,
    shouldShowNavbar,
    pageTitle,
    openNavbar,
    closeNavbar,
    openMainMenu,
    closeMainMenu,
    setPageTitle,
  }
})
